import React from "react";
import { Link, useLocation } from "react-router-dom";
import "header-pattern/dist/main-ds1-stopgap.css";
import "./Header.css";
import NavDropdownMenu from "./NavDropdownMenu";
import { Navigation } from "../../config/headerNavigations";

type NavItemProps = {
  navigation: Navigation;
};

const NavItem: React.FC<NavItemProps> = React.memo(({ navigation }) => {
  const location = useLocation();
  // Render a button+dropdown if linkList exists; otherwise render a simple link/title
  if (navigation.linkList && navigation.linkList.length > 0) {
    return (
      <li className="kp-header-global-menu__menu-item --ubt-header-nav">
        <NavDropdownMenu
          title={navigation.title}
          linkList={navigation.linkList}
        />
      </li>
    );
  }
  // If navigation has a direct href without dropdown

  // Determine the link element to render
  let linkElement: React.ReactNode;

  if (!navigation.link) {
    linkElement = (
      <span className="kp-header-global-menu__menu-label">
        {navigation.title}
      </span>
    );
  } else if (navigation.link.startsWith("http")) {
    linkElement = (
      <a
        className="kp-header-global-menu__menu-link"
        href={navigation.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {navigation.title}
      </a>
    );
  } else {
    linkElement = (
      <Link
        className={`kp-header-global-menu__menu-link ${location.pathname === navigation.link ? "--active" : ""}`}
        to={navigation.link}
      >
        {navigation.title}
      </Link>
    );
  }

  return (
    <li className="kp-header-global-menu__menu-item --ubt-header-nav">
      {linkElement}
    </li>
  );
});
NavItem.displayName = "NavItem";

export default NavItem;
